export default "__VITE_ASSET__DTq26L_s__"